/* Journal hero carousel: swipe (native scroll snap), arrows, dots, autoplay every 3.5s, loops forever.
   Starts on DOM ready. Pauses only while the pointer really moves over the card, a dot/arrow has
   keyboard focus, or during touch; resumes 2s after. Reduced motion: still rotates, with instant swaps. */
(function () {
  var INTERVAL = 3500, RESUME = 2000;
  function init(car) {
    if (car.__jhInit) return; car.__jhInit = true;
    var track = car.querySelector('.jh-car__track');
    var slides = car.querySelectorAll('.jh-slide');
    if (!track || slides.length < 2) return;
    var dots = car.querySelectorAll('.jh-dot');
    var prev = car.querySelector('[data-jh-prev]');
    var next = car.querySelector('[data-jh-next]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, hover = false, focusHeld = false, touching = false, visible = true, resumeAt = 0, lastMove = 0, animUntil = 0;

    function width() { return track.clientWidth || 1; }
    function mark(i) {
      for (var d = 0; d < dots.length; d++) {
        if (d === i) dots[d].setAttribute('aria-current', 'true'); else dots[d].removeAttribute('aria-current');
      }
    }
    function go(i, smooth) {
      var from = idx;
      idx = (i + slides.length) % slides.length;
      var left = idx * width();
      var wrap = Math.abs(idx - from) > 1;
      var soft = !(smooth === false || reduce || wrap);
      animUntil = Date.now() + (soft ? 900 : 100);
      try { track.scrollTo({ left: left, behavior: soft ? 'smooth' : 'auto' }); } catch (e) { track.scrollLeft = left; }
      mark(idx);
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf || Date.now() < animUntil) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var i = Math.round(track.scrollLeft / width());
        if (i !== idx && i >= 0 && i < slides.length) { idx = i; mark(idx); }
      });
    }, { passive: true });
    function bump() { resumeAt = Date.now() + RESUME; }
    for (var d = 0; d < dots.length; d++) {
      (function (n) { dots[n].addEventListener('click', function () { go(n); bump(); }); })(d);
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); bump(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); bump(); });
    window.addEventListener('resize', function () { go(idx, false); });

    /* pointer: only a real movement over the card counts, a cursor resting from before does not */
    car.addEventListener('mousemove', function () { hover = true; lastMove = Date.now(); }, { passive: true });
    car.addEventListener('mouseleave', function () { hover = false; bump(); });
    car.addEventListener('focusin', function (e) {
      var t = e.target;
      try { focusHeld = !!(t.matches && t.matches(':focus-visible')); } catch (x) { focusHeld = false; }
    });
    car.addEventListener('focusout', function () { focusHeld = false; bump(); });
    car.addEventListener('touchstart', function () { touching = true; }, { passive: true });
    function tEnd() { touching = false; bump(); }
    car.addEventListener('touchend', tEnd, { passive: true });
    car.addEventListener('touchcancel', tEnd, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.2 }).observe(car);
    }
    mark(0);
    setInterval(function () {
      if (touching || focusHeld || !visible || document.hidden || Date.now() < resumeAt) return;
      if (hover && Date.now() - lastMove < 1500) return;
      go(idx + 1);
    }, INTERVAL);
  }
  function boot() { var l = document.querySelectorAll('[data-jh-car]'); for (var i = 0; i < l.length; i++) init(l[i]); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
})();
